<template>
   <div class="wrapper">
        <header>
            <TheHeaderBar :title="'新闻详情'"/>
        </header>
        <div class="content">
            <div class="title">{{content.title}}</div>
            <div class="info">
                <div>{{content.created_at}}</div>
                <div>阅读:{{content.looks}}</div>
            </div>
            <div class="news-detals" v-html="content.content"></div>
        </div>
   </div>
</template>

<script>
    import TheHeaderBar from "@/components/base/TheHeaderBar";
    import {getNewsDetailsService} from '@/service/untilService'
    import { Toast } from 'vant';
	import {wecharShare} from "../../util/weChat.js";

    export default {
        data () {
            return {
                id:null,
                content:null,
            }
        },
        mounted () {
            this.id = this.$route.params.id;
            this.getNewsDetails();
			//wecharShare(location.href.split('#')[0],location.href.split('#')[1]);
        },
        methods : {
             getNewsDetails(){
                 getNewsDetailsService(this.id).then(res => {
                     if(res.status === 1){
                        this.content = res.datas;
                        console.log(this.content);
                     }else{
                         Toast(res.msg);
                     }
                 }).catch(err => {
                     console.log(err);
                 }).finally();
             },
        },
        components : {
             TheHeaderBar
             
        },
     }
</script>

<style scoped lang='scss'>
    .wrapper{
        background: #FFFFFF!important;
        header{
            padding-bottom: 46px;
        }
        .content{
            background: #FFFFFF!important;
            padding: 10px;
            box-sizing: border-box;
            .title{
                 font-size: 16px;
                font-weight: bold;
                color: #000000;
            }
            .info{
                margin-top: 10px;
                display: flex;
                align-items: center;
                justify-content: space-between;
            }
            .news-detals{
               margin-top: 20px;
            }
        }
    }
</style>
<style>
    
    .news-detals img{
        width :100%;
        height: 100%;
    }
</style>